import Button, { ButtonVariant } from '@ben/orion/deprecated-button';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

interface IAddNewPersonBlock {
  navigateAddNewDependent: () => void;
  description: string;
}

const AddNewPersonBlock = ({
  navigateAddNewDependent,
  description,
}: IAddNewPersonBlock) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Typography variant={TypographyVariant.bodyLg1}>{description}</Typography>
      <ButtonsContainer>
        <Button
          variant={ButtonVariant.primary}
          label={t('addNewPersonBlock.addNewPerson')}
          onClick={navigateAddNewDependent}
          width="180px"
        />
      </ButtonsContainer>
    </Container>
  );
};

export default AddNewPersonBlock;

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(3)};
    background-color: ${theme.palette.neutral[40]};
    border: 1px solid ${theme.palette.neutral[60]};
    border-radius: ${theme.spacing(0.5)};
    text-align: left;
  `}
`;

const ButtonsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: ${theme.spacing(2)};
  `}
`;
